module.exports = __webpack_public_path__ + "img/reward_intro1.1b9759dc.png";